import { EpimsBaseEntityDto } from './epim-base.dto';
export class IncidentSelectedActivityDto extends EpimsBaseEntityDto {
    
    EventTypeId: string;
    ActivityId: string;
    ActivityName: string;  
   
    
    IncidentTrackingNo: string;
    

}